export type PontoMotorista = [number, number, number]
/** Movimento ilustrativo: pelve e pés apoiados, tronco contido e mãos no aro. */
export function poseMotoristaImpactos(carga: number) {
  const p = Number.isFinite(carga) ? Math.max(0, Math.min(1, carga)) : 0
  const anguloTronco = p * 0.13
  const transformarTronco = ([x, y, z]: PontoMotorista): PontoMotorista => {
    const dy = y - 0.54
    return [x, 0.54 + dy * Math.cos(anguloTronco) - z * Math.sin(anguloTronco), dy * Math.sin(anguloTronco) + z * Math.cos(anguloTronco)]
  }
  const membros = [-1, 1].map(lado => ({
    lado,
    quadril: [lado * 0.115, 0.54, 0] as PontoMotorista,
    joelho: [lado * 0.145, 0.57, 0.43] as PontoMotorista,
    tornozelo: [lado * 0.145, 0.33, 0.65] as PontoMotorista,
    mao: [lado * 0.205, 1.02, 0.49] as PontoMotorista,
    ombro: transformarTronco([lado * 0.235, 1.18, 0]),
    cotovelo: [lado * 0.30, 0.97, 0.23 + p * 0.018] as PontoMotorista,
  }))
  return { carga: p, anguloTronco, transformarTronco, membros }
}
